<script>
import SetupProfile from './SetupProfile.vue'
import MultiSelect from '@/components/registration/MultiSelect.vue'
import request from '@/utils/request'

import { mapGetters } from 'vuex'
export default {
    // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        MultiSelect,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: SetupProfile, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            section: 'account-info',
            configData:{},
            customerId: null,
            message: null,
            type: null,
            existsCheck:false,
            existedPerson:null,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['form']),
    }, // End of Component > computed
    watch: {
        form(val) {
            console.log('form:', val)
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    created() {
        this.configData = this.$store.state.registration.configData
    },
    async mounted() {
        // if (this.configData.riskFactor == false ) {
        //     this.$router.push({name: 'self-registration-company-preview'})
        // }
    },
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                // alert('im here')
                if (!this.existsCheck && this.configData.restrictDuplicateCustomers) {
                    let error = false
                    let respData = null
                    try {
                        const params = {}
                        const body = {}
                        params.isCompany = true
                        params.dataSegmentId = this.dataSegmentId
                        body.dynamicInputValues =
                            this.$store.state.registration.form.dynamicInputValues
                        const { data } = await request({
                            url: '/customers/exists-company',
                            method: 'post',
                            params,
                            data:body
                        })
                        respData=data
                    } catch (e) {
                        error = e
                    }
                    if (error) {
                        // this.$store.commit('setError', error)
                        console.log("opening kyb-confirmation-popup")
                        this.openPopup('kyb-confirmation-popup','',error,'existsCheck')
                        // this.existsCheck=true
                        this.$store.commit('setLoading', false)
                        return false
                    }
                    if(respData && respData.data && !respData.success)
                    {
                        this.existedPerson = respData.data
                        // console.log('dataa----',this.existedPerson)
                        // console.log("opening kyb-confirmation-popup")

                        this.openPopup('kyb-confirmation-popup','',respData.message,'existsCheck')
                        // this.existsCheck=true
                        this.$store.commit('setLoading', false)
                        return false
                    }
                }

                this.$router.push('/self-register-company/preview')

                this.$store.commit('setLoading', false)
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
        async openPopup(popup,customerId,message,type)
        {
            this.customerId=customerId
            this.message=message
            this.type=type
            this.$bvModal.show(popup)
        },
        async updateExistsCheck(value)
        {
            if(!value) {
                // let data = this.existedPerson
                let dynamicInputValues = this.$store.getters.getField(`dynamicInputValues`)
                for(let data of this.existedPerson) {
                    let update = await this.removeItemFromArray(dynamicInputValues,data.type,data.index)
                    this.$store.commit('updateField', {
                        key: `dynamicInputValues.${data.type}`,
                        value: update[data.type],
                    })
                    this.$router.go(-1)
                }
            }
            else
            {
                this.existsCheck=value
            }
        },
        async removeItemFromArray(dataObject,arrayKey, index) {
            // Ensure the arrayKey is valid
            if (dataObject.hasOwnProperty(arrayKey) && Array.isArray(dataObject[arrayKey])) {
                // Ensure the index is valid
                if (index >= 0 && index < dataObject[arrayKey].length) {
                    // Use splice to remove the item at the specified index
                    dataObject[arrayKey].splice(index, 1);
                }
            }

            return dataObject
        },
        async tagToExistingCustomers()
        {
            this.$bvModal.hide('kyb-confirmation-popup')
            this.existsCheck=true;
            for(let data of this.existedPerson) {
                this.$store.commit('updateDynamicInputValue', {
                    parentKey: data.type,
                    index: data.index,
                    value: {...data.customer, tagged: true},
                })
            }
            this.$store.commit('setValue', {
                key: `dynamicInputValuesModified`,
                value: Math.round(1 + Math.random()*100),
            })
        },
    }, // End of Component > methods
} // End of export default
</script>
